'use client';

import {
  GridItem,
  LayoutGrid,
  TypographyRhythm,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useLocale, useTranslations } from 'next-intl';

import Section from '../_components/TAndCSection';
import SECTION_DATA from '../_data/sections';

const Content = (): JSX.Element => {
  const t = useTranslations();
  const locale = useLocale();

  return (
    <LayoutGrid>
      <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
        <TypographyRhythm>
          <TypographyV3 Element="h1" variant="h2" className="uppercase">
            {t.rich('b2b_terms_title')}
          </TypographyV3>
          <TypographyV3>{t.rich('b2b_terms_last_updated')}</TypographyV3>
          {locale === 'ja' && (
            <TypographyV3 data-cy="japanese-disclaimer">
              {t.rich('b2b_terms_translation_disclaimer')}
            </TypographyV3>
          )}
          <TypographyV3>{t.rich('b2b_terms_intro_p1')}</TypographyV3>
          <TypographyV3>{t('b2b_terms_intro_p2')}</TypographyV3>
          <TypographyV3>{t('b2b_terms_intro_p3')}</TypographyV3>
          <TypographyV3>{t('b2b_terms_intro_p4')}</TypographyV3>
          {SECTION_DATA.map((section, i) => (
            <Section {...section} index={`${i + 1}`} key={`section-${i + 1}`} />
          ))}

          <TypographyV3 className="mt-40">
            {t('legal_disclaimer_translations')}
          </TypographyV3>
        </TypographyRhythm>
      </GridItem>
    </LayoutGrid>
  );
};

export default Content;
